import { AsYouType } from 'libphonenumber-js/min';

// Formats a phone number while it's typed (2026-10-14): "+44 20 7946 0958",
// "+1 555 123 4567"; numbers without a leading + are treated as US:
// "(555) 123-4567". Pass the previous value so deleting a bracket / dash /
// space also deletes the digit before it (otherwise it would reappear).
export function formatPhoneInput(value, prev = '') {
  if (!value) return '';
  const raw = String(value).trim();
  const hasPlus = raw.startsWith('+');
  let digits = raw.replace(/\D/g, '');
  const prevDigits = String(prev || '').replace(/\D/g, '');
  if (raw.length < String(prev || '').length && digits === prevDigits && digits.length > 0) {
    digits = digits.slice(0, -1);
  }
  if (!digits) return hasPlus ? '+' : '';
  try {
    return new AsYouType(hasPlus ? undefined : 'US').input(hasPlus ? `+${digits}` : digits);
  } catch {
    return hasPlus ? `+${digits}` : digits;
  }
}
